// A thread with this many replies is where the conversation is: its reply
// count gets weight on the feed card (issue #243) so one card in a list of
// similar ones leads. Count-based on purpose: the API has no last-reply
// timestamp, so "active right now" is not knowable yet.
export const BUSY_THREAD_REPLIES = 5;

export function isBusyThread(replyCount: number | undefined): boolean {
  return (replyCount ?? 0) >= BUSY_THREAD_REPLIES;
}
